import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { useCountdown } from '../hooks/useCountdown';
export function ScarcitySection() {
  const {
    minutes,
    seconds
  } = useCountdown();
  return <section className="py-6 relative overflow-hidden bg-background-dark border-y border-card-border-dark" data-id="element-335">
      <div className="absolute inset-0 bg-gradient-to-b from-urgency/5 to-transparent pointer-events-none" data-id="element-336" />

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-337">
        <FadeIn className="text-center" data-id="element-338">
          <h2 className="text-xl md:text-2xl font-bold text-white uppercase tracking-wider mb-5" data-id="element-339">
            ⏰ EL PRECIO PROMOCIONAL TERMINA EN:
          </h2>

          <div className="flex justify-center items-center gap-3 md:gap-6 mb-5" data-id="element-340">
            <div className="flex flex-col items-center" data-id="element-341">
              <div className="text-5xl md:text-7xl font-black text-urgency font-heading tabular-nums tracking-tight animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-342">
                {minutes}
              </div>
              <span className="text-xs md:text-sm text-white font-medium mt-2 tracking-widest notranslate" translate="no" data-id="element-343">
                MIN
              </span>
            </div>
            <div className="text-4xl md:text-6xl font-black text-urgency/50 pb-6" data-id="element-344">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-345">
              <div className="text-5xl md:text-7xl font-black text-urgency font-heading tabular-nums tracking-tight animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-346">
                {seconds}
              </div>
              <span className="text-xs md:text-sm text-white font-medium mt-2 tracking-widest notranslate" translate="no" data-id="element-347">
                SEG
              </span>
            </div>
          </div>

          <p className="text-xl md:text-2xl font-bold text-white mb-6" data-id="element-348">
            Después sube el precio y no vuelve a bajar.
          </p>

          <div className="max-w-lg mx-auto" data-id="element-349">
            <div className="flex justify-between items-center mb-2" data-id="element-350">
              <div className="flex items-center gap-2" data-id="element-351">
                <span className="w-2.5 h-2.5 rounded-full bg-primary animate-pulse" data-id="element-352" />
                <span className="text-primary font-medium text-sm" data-id="element-353">
                  Cupos al precio promocional
                </span>
              </div>
              <span className="text-white font-bold text-sm" data-id="element-354">Quedan pocos</span>
            </div>

            <div className="h-3 w-full bg-card-border-dark rounded-full overflow-hidden mb-2" data-id="element-355">
              <div className="h-full bg-primary rounded-full" style={{
              width: '65%'
            }} data-id="element-356" />
            </div>

            <div className="text-right" data-id="element-357">
              <span className="text-gray-400 text-xs" data-id="element-358">
                Precio promocional activo por tiempo limitado
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}